import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import siteQueries from '../../queries/siteQueries';
import { BASE_URL } from '../../apis/api';
import RouteConstants from '../../constant/Routeconstant';
import MainHeader from './MainHeader';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';
import Footer from './Footer';
import Loader from './Loader';
import { useScrollToTop } from '../../hooks/ScrollTop';

export default function SpeakerView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [speaker, setSpeaker] = useState(null);
  const [relatedSpeakers, setRelatedSpeakers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const viewSpeakerMutation = siteQueries.useSpeakerviewsiteMutation((response) => {
    setSpeaker(response?.data);
    setIsLoading(false);
  });

    const speakerList = siteQueries.useSpeakerListingMutation((response) => {
    const related = response?.data?.items?.filter((sp) => sp.id !== parseInt(id))?.slice(0, 3);
    setRelatedSpeakers(related || []);
    setIsLoading(false);
  });
    
  useEffect(() => {
    if (id) {
      viewSpeakerMutation.mutateAsync(id);
      speakerList.mutateAsync({ page: 0, size: 10, heading: ''});
    }
  }, [id]);

  useScrollToTop();
  return (
    <>
     <MainHeader />
     {isLoading ? (
             <Loader />
           ) : (
    <div className="min-h-screen bg-slate-100 py-8">
        
          {/* <div className="bg-gradient-to-br from-gray-800 to-blue-400 from-blue-200 text-bla py-4 relative overflow-hidden">
                        <div className="relative z-5 text-center px-4">
                            <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                <span className="text-yellow-400">Speaker:</span> {speaker?.heading}
                            </h1>
                           
                        </div>
                    </div> */}
                      <div className="min-h-[190px] flex justify-center items-center py-4 relative overflow-hidden" 
                              style={{
                                       backgroundImage: `url(${BannerBg})`,
                                       backgroundSize: 'cover',
                                       backgroundPosition: 'center',
                                       backgroundRepeat: 'no-repeat',
                                   }}>
                                            <div className="relative z-5 text-center px-4">
                                                 <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                                    <span className="text-yellow-400 text-[36px]">Speaker:</span> {speaker?.heading}
                                                </h1>
                                                </div>
                                        </div>
      <div className="max-w-6xl mx-auto">
        {/* Breadcrumb */}
        {/* <nav className="mb-6">
          <ol className="flex items-center space-x-2 text-sm text-gray-600">
            <li 
              className="hover:text-gray-900 cursor-pointer" 
              onClick={() => navigate('/')}
            >
              Home
            </li>
            <li>/</li>
            <li 
              className="hover:text-gray-900 cursor-pointer" 
              onClick={() => navigate('/speakers')}
            >
              Speakers
            </li>
            <li>/</li>
            <li className="text-gray-900 font-medium">{speaker?.heading}</li>
          </ol>
        </nav> */}

        <div className="flex flex-col lg:flex-row gap-8 mt-6">
          {/* Main Speaker Card */}
          <div className="flex-1 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="p-6 md:p-8">
              <div className="flex flex-col md:flex-row gap-6">
                {/* Speaker Image */}
                <div className="relative flex-shrink-0">
                  <img
                    src={`${BASE_URL}/${speaker?.photo}`}
                    alt={speaker?.heading}
                    className="w-48 h-48 rounded-lg object-cover shadow-md"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/placeholder-speaker.jpg';
                      e.target.className = 'w-48 h-48 rounded-lg object-cover bg-gray-200';
                    }}
                  />
                  {/* <div className="absolute -bottom-3 -right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-medium shadow">
                    Speaker
                  </div> */}
                </div>

                {/* Speaker Details */}
                <div className="flex-1">
                  {/* <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                    {speaker?.heading}
                  </h1> */}
                  <h2 className="text-lg text-gray-600 mb-4">
                    Speaker: <span>{speaker?.heading}</span>
                  </h2>

                  {/* Speaker Content */}
                  <div className="prose max-w-none text-gray-700">
                    {speaker?.content && (
                      <div dangerouslySetInnerHTML={{ __html: speaker.content }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Related Speakers */}
          <div className="w-full lg:w-80 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Other Speakers
              </h3>
              
              <div className="space-y-4">
                {relatedSpeakers.map((speaker) => (
                  <div
                    key={speaker.id}
                    onClick={() => navigate(RouteConstants.SPEAKERVIEWILFK.replace(':id', speaker.id))} 
                    className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                  >
                    <img
                      src={`${BASE_URL}/${speaker?.photo}`}
                      alt={speaker.heading}
                      className="w-12 h-12 rounded-md object-cover"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/placeholder-speaker.jpg';
                        e.target.className = 'w-12 h-12 rounded-md bg-gray-200';
                      }}
                    />
                    <div>
                      <h4 className="font-medium text-gray-900 line-clamp-1">
                        {speaker.heading}
                      </h4>
                      <p className="text-sm text-gray-500 line-clamp-1">
                        {speaker.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <button
                onClick={() => navigate(RouteConstants.SPEAKERLISTSITEILFK)}
                // className="mt-4 w-full text-center py-2 text-sm font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors"
                className="mt-4 w-full text-center py-2 text-sm font-medium bg-[#efc847] hover:bg-[#f0872a87] text-black rounded-lg transition-colors"
              >
                View All Speakers →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
           )}
    <Footer/>
  </>

  );
}